import { render, staticRenderFns } from "./ModListUserEditRoleComp.vue?vue&type=template&id=17ea4ae6&scoped=true&"
import script from "./ModListUserEditRoleComp.vue?vue&type=script&lang=ts&"
export * from "./ModListUserEditRoleComp.vue?vue&type=script&lang=ts&"
import style0 from "./ModListUserEditRoleComp.vue?vue&type=style&index=0&id=17ea4ae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ea4ae6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VBtnToggle,VTooltip})
